export default Object.freeze({
  Duplicado: 1,
  BalanceCero: 2,
  NoLocalizadoEncargado: 3,
  Reclamacion: 4,
});
